import { __assign, __rest } from "tslib";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useScrollAware } from '@wix/da-hooks/pkg/useScrollAware';
import StickyContent from './StickyContent';
function getHeight(node) {
    if (!node) {
        return 0;
    }
    return node.getBoundingClientRect().height;
}
var Sticky = function (_a) {
    var _b = _a.marginTop, marginTop = _b === void 0 ? 0 : _b, _c = _a.marginLeft, marginLeftProp = _c === void 0 ? 0 : _c, _d = _a.bottomStop, bottomStop = _d === void 0 ? 0 : _d, usePortal = _a.usePortal, contentProps = __rest(_a, ["marginTop", "marginLeft", "bottomStop", "usePortal"]);
    var rootRef = useRef(null);
    var innerRef = useRef(null);
    var _e = useState(getHeight(innerRef.current)), minHeight = _e[0], setMinHeight = _e[1];
    var _f = useState(0), top = _f[0], setTop = _f[1];
    var _g = useState(typeof marginLeftProp === 'number' ? marginLeftProp : 0), marginLeft = _g[0], setMarginLeft = _g[1];
    var checkIfStuck = useCallback(function () {
        if (!rootRef.current) {
            return false;
        }
        var rootRect = rootRef.current.getBoundingClientRect();
        return rootRect.top - marginTop <= 0;
    }, [marginTop]);
    var _h = useState(checkIfStuck()), isStuck = _h[0], setIsStuck = _h[1];
    var updateTop = useCallback(function (_a) {
        var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        var isStuckNow = checkIfStuck();
        setIsStuck(isStuckNow);
        var height = minHeight || getHeight(innerRef.current);
        setMinHeight(height);
        if (isStuckNow && bottomStop !== 0) {
            var diff = scrollHeight - scrollTop - height - marginTop - bottomStop;
            setTop(diff < 0 ? diff : 0);
            return;
        }
        setTop(0);
    }, [checkIfStuck, minHeight, bottomStop, marginTop]);
    useScrollAware(updateTop);
    useEffect(function () {
        if (marginLeftProp === 'preserve') {
            var clientRectLeft = innerRef.current.getBoundingClientRect().left;
            setMarginLeft(clientRectLeft);
        }
    }, [marginLeftProp]);
    var content = (React.createElement(StickyContent, __assign({ isStuck: isStuck, top: top, marginTop: marginTop, marginLeft: marginLeft, ref: innerRef }, contentProps)));
    return (React.createElement("div", { ref: rootRef, style: { minHeight: minHeight } }, usePortal && isStuck
        ? ReactDOM.createPortal(content, document.body)
        : content));
};
Sticky.displayName = 'Sticky';
export default Sticky;
//# sourceMappingURL=Sticky.js.map